module.exports = __webpack_public_path__ + "static/media/rocket.0607cebe.png";